import React from 'react'
import Footer from './Footer';
import Hero from './casazen/Hero';
import Section2 from './casazen/Section2';
import Section1 from './casazen/Section1';
import Section3 from './casazen/Section3';
import Section4 from './casazen/Section4';
import Section5 from './casazen/Section5';

const Casazen = () => {
  return (
    <>
        <Hero />
        <Section2 />
        <Section1 />
        <Section3 />
        <Section4 />
        <Section5 />
        <Footer />
    </>
  )
}

export default Casazen